import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  ThreadsShareButton,
  FacebookIcon,
  WhatsappIcon,
  ThreadsIcon,
  XIcon
} from 'react-share';
import styled from 'styled-components';
import qrCode from '../../assets/images/qr-code.svg';
import { useState } from 'react';
import QRCode from 'react-qr-code';
import { SingleShareButton } from './SingleShareButton';

const ShareButtonsDiv = styled.div`
  display: flex;
  justify-content: right;
  align-items: right;
  gap: 10px;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

const DownloadButton = styled.a`
  background: var(--moss-green);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 50px;
  right: 50px;
  background: none;
  border: none;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
  z-index: 1001;
`;

export const ShareButtons = ({title, shareUrl}) => {
  const [showModal, setShowModal] = useState(false);

  const downloadQRCode = () => {
    const svg = document.getElementById("qr-code");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = `qr-code-${title}`.replace(/\s+/g, "-");
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  return (
    <>
      <ShareButtonsDiv>
        <SingleShareButton shareUrl={shareUrl} title={title} />

        <FacebookShareButton url={shareUrl} quote={title}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl} title={title}>
          <XIcon size={32} round />
        </TwitterShareButton>

        <WhatsappShareButton url={shareUrl} title={title}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>

        <ThreadsShareButton url={shareUrl} title={title}>
          <ThreadsIcon size={32} round />
        </ThreadsShareButton>
        <img 
          src={qrCode} 
          alt="view or download the QR Code for this page" 
          onClick={() => setShowModal(true)} 
          style={{ cursor: 'pointer' }}
        />
      </ShareButtonsDiv>

      {showModal && (
        <Modal>
          <ModalContent>
            <CloseButton onClick={() => setShowModal(false)}><i className="fas fa-times"></i></CloseButton>
            <QRCode
              id="qr-code"
              value={shareUrl}
              size={256}
              level="H"
            />
            <DownloadButton onClick={downloadQRCode}>
              <i className="fas fa-download"></i>&nbsp;
              Download QR Code
            </DownloadButton>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};